import React from 'react';
import { Poppins } from 'src/common';
import styled from 'styled-components';

export const Wrap = styled.div`
  margin-top: 1px;
  border: 1px solid ${({ theme }) => theme.colors.stroke};
  padding: 20px;
  background-color: ${({ theme }) => theme.colors.cultured};
  /* max-width: 800px; */

  /* Task 001 round 2: a grid item defaults to min-width auto, so a single unbreakable token — a
     long cost note with no spaces — forced its track wider than the table and put a horizontal
     scrollbar under the whole sheet. minmax(0, 1fr) lets the track shrink; the wrapping below is
     what then makes the content fit inside it. */
  .grid {
    display: grid;
    grid-column-gap: 8px;
    min-width: 0;

    > * {
      min-width: 0;
    }

    &--2 {
      grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    }
    &--3 {
      grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr);
    }
  }

  .value {
    border: 1px solid ${({ theme }) => theme.colors.stroke};
    background: ${({ theme }) => theme.colors.white};
    border-radius: 4px;
    padding: 14px 20px;
    font-size: 14px;
    font-weight: 500;
    min-height: 50px;
    flex: 1;
    min-width: 0;
    /* pre-wrap keeps newlines; on its own it will not break a long unbroken run, which is how a
       cost note of solid characters escaped the sheet. overflow-wrap anywhere breaks it at the
       box edge. */
    white-space: pre-wrap;
    overflow-wrap: anywhere;
    color: ${({ theme }) => theme.colors.prussianBlue};
  }

  .divider {
    border-bottom: 1px solid ${({ theme }) => theme.colors.stroke};
    position: relative;
    left: -20px;
    width: calc(100% + 40px);
  }

  ${({ theme }) => theme.breakpoints.down('sm')} {
    .value {
      min-height: 40px;
      padding: 10px 16px;
    }
  }
  ${({ theme }) => theme.breakpoints.down('sm')} {
    padding: 14px;
    .value {
      min-height: 24px;
      padding: 6px 8px;
      font-size: 12px;
    }
  }
`;

export const Label = styled(Poppins).attrs({ weight: 500, px: 14 })`
  white-space: nowrap;
  color: ${({ theme }) => theme.colors.prussianBlue};

  ${({ theme }) => theme.breakpoints.down('sm')} {
    font-size: 12px;
  }
`;
